module.exports = __webpack_public_path__ + "img/VL_13_01.95604252.png";